import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class CornerNameFromImageModel extends QuestionExtendedModel {

  model = {
    corner: Enums.Corners.right,
    possibleAnswers: [],
    numAnswers: 3
  };

  static generateModel(json: any): CornerNameFromImageModel {

    const q = new CornerNameFromImageModel();

    const model = json.model;

    if (model) {

      if (model.possibleAnswers instanceof Array) {
        q.model.possibleAnswers = model.possibleAnswers;
      }

      q.model.corner = model.corner;
      q.model.numAnswers = model.numAnswers;

    }

    return q;

  }

}
